import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Observable";
import { StoreStatus } from "./store-status";
import { SearchTableState } from "../../admin/search-table-state";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class StoreStatusService {

    private static getStoreStatusUrl: string = '/api/dashboard/getStoreStatus';
    public searchTableState: SearchTableState = null;

    constructor(
        private http: HttpClient
    ) {
        this.searchTableState = new SearchTableState();
        this.searchTableState.propertyName = 'StoreGroupCode';
    }

    public search(): Observable<Array<StoreStatus>> {
        return this.http.post<Array<StoreStatus>>(StoreStatusService.getStoreStatusUrl, this.searchTableState);
    }
};


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dashboards/store-status/store-status.service.ts